import React from "react";

import TasksTable from "./TasksTable";
import api from "lib/api";

interface Props {
	search: string;
}

const All = ({ search }: Props) => {
	return (
		<TasksTable
			search={search}
			requestTasks={api.workflow.getAllTasksAsAdmin}
		/>
	);
};

export default All;
